import { motion, MotionValue, useTransform } from "motion/react";

interface WordProps {
  word: string;
  range: [number, number];
  progress: MotionValue<number>;
  size?: "sm" | "md" | "lg";
  isHighlighted?: boolean;
}

export const Word = ({
  word,
  range,
  progress,
  size = "sm",
  isHighlighted = false,
}: WordProps) => {
  const opacity = useTransform(progress, range, [0, 1]);

  return (
    <span
      className={` ${size === "sm" ? "ml-1 sm:ml-2" : size === "md" ? "ml-1.5 sm:ml-2" : "ml-4 sm:ml-8 lg:ml-12"} relative `}
    >
      <span
        className={` ${isHighlighted ? " font-nyght-serif-light-italic " : "font-gilroy-regular"} absolute text-white opacity-10 ${
          size === "sm"
            ? "text-base sm:text-caption1"
            : size === "md"
              ? "text-lg sm:text-xl lg:text-[32px]"
              : "text-lg sm:text-2xl lg:text-h1"
        }`}
      >
        {word}
      </span>
      <motion.span
        style={{ opacity: opacity }}
        className={` ${isHighlighted ? " font-nyght-serif-light-italic" : "font-gilroy-regular"} ${
          size === "sm"
            ? "text-base sm:text-caption1"
            : size === "md"
              ? "text-lg sm:text-xl lg:text-[32px]"
              : "text-lg sm:text-2xl lg:text-h1"
        }`}
      >
        {word}
      </motion.span>
    </span>
  );
};
